// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Selectors
import { getRemoteCurrentlyViewedBoardIds } from './remoteUsersSelector';

// Services
import * as elementService from '../../element/elementService';

const mapStateToProps = createStructuredSelector({
    currentlyViewedBoardIds: getRemoteCurrentlyViewedBoardIds,
});

const mapDispatchToProps = (dispatch) => ({
    fetchElements: (elementIds) => dispatch(elementService.fetchElements({ elementIds, loadAncestors: true })),
});

const RemoteUserCurrentlyViewedBoardManager = (props) => {
    const { currentlyViewedBoardIds, fetchElements } = props;

    React.useEffect(() => {
        fetchElements(currentlyViewedBoardIds);
    }, [currentlyViewedBoardIds]);

    return null;
};

RemoteUserCurrentlyViewedBoardManager.propTypes = {
    currentlyViewedBoardIds: PropTypes.array,
    fetchElements: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(RemoteUserCurrentlyViewedBoardManager);
